const iconBasePath = '/wp-content/themes/rm-schools/img/pin/'
var prev_infowindow = false
window.POIs = []

window.POIMapUpdate = function() {
    // remove existing markers
    POIs.forEach(function (POI, i) {
        if (POI.marker) {
            POI.marker.setMap(null)
        }
    })
    let filter = []
    let catBtns = document.querySelectorAll('.POIfilterCb:not(:checked)')
    for (var btn of catBtns) {
        filter.push(btn.getAttribute('data-poicat'))
    }
    console.log('filtered out:', filter)
    POIs = window.PointsOfInterest.filter(POI => !filter.includes(POI.type))
    console.log('no of POIs:', POIs.length)
    // show info window when marker is clicked
    function highlight(clickedItem) {
        var selItem = POIs[clickedItem]
        if (prev_infowindow) {
            prev_infowindow.close()
        }
        var infowindow = new google.maps.InfoWindow({ content: selItem.marker.infoWindowContent })
        infowindow.open(map, selItem.marker)
        prev_infowindow = infowindow
    }
    if (POIs.length > 0) {
        POIs.forEach(function (POI, i) {
            // create list items
            if (window.map) { // create map markers
                var popupContent = [
                    `<img class="poi-popup--icon" src="${iconBasePath + POI.type + '.svg'}">`,
                    `<span class="poi-popup--type">${POI.type}</span><br><br>`,
                    `<span class="poi-popup--title">${POI.title}</span><br>`,
                    `<span class="poi-popup--address">${POI.address}<br>${POI.zip} ${POI.city}</span><br><br>`,
                    `<a class="poi-popup--mapslink" href="https://www.google.com/maps/search/${POI.lat},${POI.lng}" target="_blank">Google Maps</a> `,  
                ]
                if (POI.url) {
                    popupContent.push(`<a class="poi-popup--url" href="${POI.url}" target="_blank">Website</a>`)
                }
                POI.markerData = {
                    listIndex: i,
                    map: window.map,
                    title: POI.title,
                    icon: {
                        url: iconBasePath + POI.type + '.svg',
                        size: new google.maps.Size(30, 38),
                        scaledSize: new google.maps.Size(30, 38),
                    },
                    position: {lat: parseFloat(POI.lat), lng: parseFloat(POI.lng)},
                    infoWindowContent: `<div class="poi-popup">${popupContent.join(' ')}</div>`
                } 
                POI.marker = new google.maps.Marker(POI.markerData)
                POI.marker.addListener('click', function() {highlight(i)})
            }
        })
    }
}

window.POIMap = (function () {
    'use strict'
    const elementId = 'POIMap'
    const filterButtonsId = 'POIMapFilterButtons'
    const mapsApiKey = 'AIzaSyCA0KQ0X3B-vccXf0e-5kv4Wr-Gw1YpsIE'
    const mapsApiSrc = 'https://maps.googleapis.com/maps/api/js?key=' + mapsApiKey // + '&language=de&region=DE'

    /**
     * @function initMap
     * Initialize Google Map
     */
    function initMap() {
        function initMapCallback() {
            var mapArea = document.getElementById(elementId)
            window.map = new google.maps.Map(mapArea, {
                center: { lat: 51.0, lng: 10.5 },
                zoom: 4,
                zoomControl: true,
                streetViewControl: false,
                styles: require('./map-styles.json')
            })
            POIMapUpdate()
        }
        const existingScript = document.getElementById('googleMaps')
        if (!existingScript) {
            const script = document.createElement('script')
            script.src = mapsApiSrc
            script.id = 'googleMaps'
            document.body.appendChild(script)
            script.onload = initMapCallback
        }
        if (existingScript) initMapCallback()
    }

    function renderFilterButtons() {
        let POIcategories = [...new Set(window.PointsOfInterest.map(poi => poi.type))]
        let filterButtonsEl = document.getElementById(filterButtonsId)
        POIcategories.forEach(category => {
            let li = document.createElement('li')
            li.setAttribute('class', 'POIfilter')
            li.innerHTML = `<label class="noselect" onclick="javascript:POIMapUpdate()"><input class="POIfilterCb" type="checkbox" data-poicat="${category}" checked><span class="catBtn-${category}">${category}</span></label>`
            filterButtonsEl.appendChild(li)
        })
    }

    initMap()
    renderFilterButtons()

})() // Immediately invoked function expression
